import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const SubscriptionCard = ({
  subscriptionPlan,
  isLoading = false,
  isDisabled = false,
  onClick,
  variant = "default", // "default" | "compact" | "modal"
  title,
  description,
  buttonText,
  showLoginPrompt = false,
}) => {
  const { t } = useTranslation();

  if (!subscriptionPlan) {
    return null;
  }

  const benefits = [
    "無限制發送訊息",
    "免鑽石觀看創作者貼文",
    "免鑽石觀看創作者所有影片",
  ];

  const priceText = subscriptionPlan.interval === "month" 
    ? `$${subscriptionPlan.price.toFixed(2)} USD / 月`
    : `$${subscriptionPlan.price.toFixed(2)} USD / ${subscriptionPlan.interval}`;
  const originalPriceText = `$${subscriptionPlan.originalPrice?.toFixed(2)} `;

  const defaultTitle = t("chats.subscription_required", { defaultValue: "需要訂閱" });
  const defaultDescription = t("chats.subscribe_to_chat_unlimited", { defaultValue: "訂閱後即可無限聊天" });

  if (variant === "compact") {
    return (
      <Box px={4} py={4} bg="whiteAlpha.100" borderRadius={8} mx={4} my={4}>
        <Flex direction="column" align="center" gap={3}>
          <Text fontSize="lg" fontWeight="bold">
            訂閱方案
          </Text>
          <Flex align="center" gap={2}>
            {subscriptionPlan.originalPrice && subscriptionPlan.originalPrice > subscriptionPlan.price && (
              <Text
                as="span"
                fontSize="2xl"
                fontWeight="bold"
                color="red.400"
                textDecoration="line-through"
                mr={2}
              >
                {originalPriceText}
              </Text>
            )}
            <Text fontSize="2xl" fontWeight="bold" color="secondary.500" as="span">
              {priceText}
            </Text>
          </Flex>
          <VStack align="start" spacing={2} width="100%" mt={2}>
            {benefits.map((benefit, index) => (
              <Flex key={index} align="center" gap={2}>
                <Text fontSize="sm" color="whiteAlpha.900">
                  ✓
                </Text>
                <Text fontSize="sm" color="whiteAlpha.900">
                  {benefit}
                </Text>
              </Flex>
            ))}
          </VStack>
          <Button
            colorScheme="secondary"
            size="lg"
            width="100%"
            onClick={onClick}
            isLoading={isLoading}
            isDisabled={isDisabled}
            mt={4}
          >
            {buttonText || (showLoginPrompt ? t("errors.login_required", { defaultValue: "請先登入" }) : t("chats.subscribe_now", { defaultValue: "立即訂閱" }))}
          </Button>
        </Flex>
      </Box>
    );
  }

  if (variant === "modal") {
    return (
      <Box>
        <Box mb={4}>
          <Text fontSize="xl" fontWeight="bold" textAlign="center" mb={2}>
            {title || defaultTitle}
          </Text>
          <Text fontSize="sm" textAlign="center" color="whiteAlpha.700" mb={4}>
            {description || defaultDescription}
          </Text>
          <Box mt={4} bg="whiteAlpha.100" p={4} borderRadius={8}>
            <Text fontSize="lg" fontWeight="bold" textAlign="center" color="secondary.500" mb={4}>
              {priceText}
            </Text>
            <VStack align="start" spacing={2} mt={2}>
              {benefits.map((benefit, index) => (
                <Flex key={index} align="center" gap={2} width="100%">
                  <Text fontSize="md" color="secondary.500" fontWeight="bold">
                    ✓
                  </Text>
                  <Text fontSize="md" color="whiteAlpha.900">
                    {benefit}
                  </Text>
                </Flex>
              ))}
            </VStack>
          </Box>
        </Box>
        <Button
          colorScheme="secondary"
          size="lg"
          width="100%"
          onClick={onClick}
          isLoading={isLoading}
          isDisabled={isDisabled}
        >
          {buttonText || (showLoginPrompt ? t("errors.login_required", { defaultValue: "請先登入" }) : t("chats.subscribe_now", { defaultValue: "立即訂閱" }))}
        </Button>
      </Box>
    );
  }

  // Default variant
  return (
    <Box px={4} py={4} bg="whiteAlpha.100" borderRadius={8} mx={4} my={4}>
      <Flex direction="column" align="center" gap={3}>
        <Text fontSize="lg" fontWeight="bold">
          訂閱方案
        </Text>
        <Text fontSize="2xl" fontWeight="bold" color="secondary.500">
          {priceText}
        </Text>
        <VStack align="start" spacing={2} width="100%" mt={2}>
          {benefits.map((benefit, index) => (
            <Flex key={index} align="center" gap={2}>
              <Text fontSize="sm" color="whiteAlpha.900">
                ✓
              </Text>
              <Text fontSize="sm" color="whiteAlpha.900">
                {benefit}
              </Text>
            </Flex>
          ))}
        </VStack>
        <Button
          colorScheme="secondary"
          size="lg"
          width="100%"
          onClick={onClick}
          isLoading={isLoading}
          isDisabled={isDisabled}
          mt={4}
        >
          {t("chats.subscribe_now", { defaultValue: "立即訂閱" })}
        </Button>
      </Flex>
    </Box>
  );
};

export default SubscriptionCard;
